<template>
  <div class="ls-leads-success-view--container">
    <LsIcon type="thumbsup" :size-override="!screenSize.desktop ? 77 : 96" />
    <span class="ls-leads-success-view--heading">Congrats! The hard part is over.</span>
    <span class="ls-leads-success-view--body">
      Now it's time to kick back and get multiple quotes over the next few hours. Hit continue to
      give your pros more details about the job.
    </span>
    <LsButton
      class="ls-leads-success-view--button"
      text="continue"
      track-id="leads_success_view-continue"
      @click="onContinue"
    />
  </div>
</template>

<script>
import { LsButton, LsIcon } from '@/components/common';
import { mapState, mapActions } from 'vuex';
import { ONBOARDING__GOTO_NEXT } from '@/store/types';

export default {
  name: 'OnboardingLeadsSuccessView',
  components: {
    LsIcon,
    LsButton,
  },
  computed: {
    ...mapState(['screenSize']),
  },
  methods: {
    ...mapActions([ONBOARDING__GOTO_NEXT]),
    onContinue() {
      this[ONBOARDING__GOTO_NEXT]();
    },
  },
};
</script>

<style scoped lang="scss">
.ls-leads-success-view--container {
  padding: 207px 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.ls-leads-success-view--heading {
  font-weight: 700;
  font-size: 30px;
  color: $primary;
  text-align: center;
  margin: 30px 0 20px 0;
}

.ls-leads-success-view--body {
  font-size: 16px;
  text-align: center;
  margin-bottom: 30px;
}
.ls-leads-success-view--button {
  min-width: 300px;
}

@media (max-width: $mobile-max-width) {
  .ls-leads-success-view--container {
    padding: 16px 0 0 0;
    height: calc(100vh - 114px);
  }

  .ls-leads-success-view--heading {
    font-weight: 600;
    font-size: 20px;
    color: $primary;
    text-align: center;
    margin: 20px 0 10px 0;
  }

  .ls-leads-success-view--body {
    font-size: 14px;
    text-align: center;
  }

  .ls-leads-success-view--button {
    margin-top: auto;
    margin-bottom: 20px;
  }
}
.themed-app {
  .ls-leads-success-view--heading {
    color: $theme-color-primary;
  }
  @media (max-width: $mobile-max-width) {
    .ls-leads-success-view--heading {
      color: $theme-color-primary;
    }
  }
}
</style>
